import asyncLoadView from 'utils/asyncLoadView/asyncLoadView';
import routeArgsToInt from 'router/utils/routeArgsToInt';
import store from 'store';

const aoriRoutes = [
  {
    path: '/accounts/:accountId(\\d+)/balance',
    name: 'aoriBalance',
    component: () => asyncLoadView(import('pages/aori/AoriBalance')),
    props: routeArgsToInt,
    meta: {
      hideBreadcrumbs: true,
      hideHeaderTabs: true
    },
    beforeEnter (to, from, next) {
      if (!store.getters['common/isAori'] || !store.getters['user/canUser']('READ_AORI_USER_BALANCE')) {
        next({name: '403page', replace: true});
      } else {
        next();
      }
    }
  }
];

export default aoriRoutes;
